import RechargeCenter from '../views/otherSettings/rechargeCenter.vue'
import RechargeCenterForm from '../views/otherSettings/rechargeCenterGoods.form.vue'
import DictList from '../views/otherSettings/dictList.vue'

export default [
  {
    path: '/otherSettings/rechargeCenter',
    name: 'rechargeCenter',
    component: RechargeCenter,
  },
  {
    path: '/otherSettings/rechargeCenter/form',
    name: 'rechargeCenterForm',
    component: RechargeCenterForm,
  },
  {
    path: '/otherSettings/dictList',
    name: 'dictList',
    component: DictList,
  }
]